import { useState } from 'react';
import { analyzeVideo, getAnalysis } from '../services/api';
import type { Analysis } from '../types';

export const useAnalysis = () => {
  const [analysis, setAnalysis] = useState<Analysis | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const startAnalysis = async (videoUrl: string) => {
    try {
      setLoading(true);
      setError(null);
      const response = await analyzeVideo({ video_url: videoUrl });
      
      const pollAnalysis = async () => {
        const maxAttempts = 60;
        let attempts = 0;
        
        const interval = setInterval(async () => {
          attempts++;
          try {
            const result = await getAnalysis(response.analysis_id);
            setAnalysis(result);
            
            if (result.status === 'completed' || result.status === 'failed') {
              clearInterval(interval);
              setLoading(false);
            }
          } catch (err: any) {
            if (attempts >= maxAttempts) {
              clearInterval(interval);
              setLoading(false);
              setError('Analysis timeout. Please try again.');
            }
          }
        }, 2000);
      };
      
      await pollAnalysis();
    } catch (err: any) {
      setError(err.message || 'Failed to start analysis');
      setLoading(false);
    }
  };

  const reset = () => {
    setAnalysis(null);
    setError(null);
    setLoading(false);
  };

  return {
    analysis,
    loading,
    error,
    startAnalysis,
    reset
  };
};

